export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const MODAL_OPEN  = 'MODAL_OPEN' ;
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_INIT  = 'MODAL_INIT' ;
export const SUBMODAL_OPEN = 'SUBMODAL_OPEN';
export const SUBMODAL_CLOSE = 'SUBMODAL_CLOSE';
export const INIT_MODAL_CALLBACK  = 'INIT_MODAL_CALLBACK' ;
export const CLEAR_MODAL_CALLBACK  = 'CLEAR_MODAL_CALLBACK' ;
export const MODAL_CONFIRM_OPEN  = 'MODAL_CONFIRM_OPEN' ;
export const MODAL_CONFIRM_CLOSE = 'MODAL_CONFIRM_CLOSE';
export const MODAL_CONFIRM_YES  = 'MODAL_CONFIRM_YES' ;
export const MODAL_CONFIRM_NO = 'MODAL_CONFIRM_NO';
export const MODAL_SAVE = 'MODAL_SAVE';
export const MODAL_PICK_OPEN  = 'MODAL_PICK_OPEN';
export const MODAL_PICK_OPEN_WITH_ACTION  = 'MODAL_PICK_OPEN_WITH_ACTION';
export const MODAL_PICK_SAVE  = 'MODAL_PICK_SAVE';
export const MODAL_PICK_CLOSE = 'MODAL_PICK_CLOSE';
export const GET_CURRENT_TIME = "GET_CURRENT_TIME";
export const DO_GET_DATE = "DO_GET_DATE";
export const MODAL_LOADING_OPEN = "MODAL_LOADING_OPEN";
export const MODAL_LOADING_CLOSE = "MODAL_LOADING_CLOSE";
export const MODAL_ALERT_OPEN = "MODAL_ALERT_OPEN";
export const MODAL_ALERT_CLOSE = "MODAL_ALERT_CLOSE";
export const SEND_NOTIFY_MSG = "SEND_NOTIFY_MSG";
export const MODAL_TIP_OPEN = "MODAL_TIP_OPEN";
export const MODAL_TIP_CLOSE = "MODAL_TIP_CLOSE";
export const UPLOAD_FILE_INIT = "UPLOAD_FILE_INIT";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";

export const fetchDataPromise = (req, funName, resolve, reject) => {
    fetch(req)
        .then((response) => {
            if (response.ok) {
                if (response.json) {
                    resolve(response.json());
                } else {
                    reject(funName + ' response format error.');
                }
            } else {
                resolve(response.json());
            }
        }).catch((err) => {
            reject(err);
        });
}

export const fetchFilePromise = (req, funName, resolve, reject) => {
    fetch(req)
        .then((response) => {
            if (response.ok) {
                if (response.blob) {
                    resolve(response.blob());
                } else {
                    reject(funName + ' response format error.');
                }
            } else {
                reject(funName + ' response error.');
            }
        }).catch((err) => {
            reject(err);
        });
}

export const openModal = (modalStatus, modalMessage, modalRedirect, callback) => (dispatch) => {

    let commonParams = {
        modalStatus: modalStatus,
        modalMessage: modalMessage,        
        modalRedirect: modalRedirect,
        callback: callback
    }

    dispatch({
        type: MODAL_OPEN,
        commonParams: commonParams
    });

    if (callback) {
        callback();
    }
 }
 
 export const closeModal = (modalRedirect, callback) => (dispatch) => {
    
    let commonParams = {
        modalStatus: null,
        modalMessage: null,
        modalRedirect: null,
        callback: null
    }

    dispatch({
        type: MODAL_CLOSE,
        commonParams: commonParams
    });

    if (typeof callback === 'function') {
        callback();
    }

    if (modalRedirect) {
        // do redirect page
    }
 }

export const openSubModal = (modalStatus, modalMessage, modalData, callback) => (dispatch) => {

    let commonParams = {
        subModal: {
            modalStatus: modalStatus,
            modalMessage: modalMessage,
            modalData: modalData
        }
    }

    dispatch({
        type: SUBMODAL_OPEN,
        params: commonParams
    });

    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
}
 
export const closeSubModal = (callback) => (dispatch) => {
    
    let commonParams = {
        subModal: {
            modalStatus: null,
            modalMessage: null,
            modalData: null
        }
    }

    dispatch({
        type: SUBMODAL_CLOSE,
        params: commonParams
    });


    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
}

export const popupModalConfirm = (confirmTitle, confirmIcon, confirmText, confirmHeight, confirmCallback, cancelCallback, doubleConfirm) => (dispatch) => {
    dispatch({
        type: MODAL_CONFIRM_OPEN,
        commonParams: {
            confirmTitle: confirmTitle,
            confirmIcon: confirmIcon,
            confirmText: confirmText,
            confirmHeight: confirmHeight,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            doubleConfirm: doubleConfirm
        }
    });
}

export const doShowModalConfirm = (confirmText, confirmCallback, cancelCallback) => (dispatch) => {
    dispatch({
        type: MODAL_CONFIRM_OPEN,
        commonParams: {
            confirmText: confirmText,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback
        }
    });
}

export const doCloseModalConfirm = () => (dispatch) => {
    dispatch({
        type: MODAL_CONFIRM_CLOSE
    });
}

export const doSaveModal = (disableButton, comfirmFlag, saveData) => (dispatch) => {
    dispatch({
        type: MODAL_SAVE,
        commonParams: {
            disableButton: disableButton,
            confirm: comfirmFlag,
            data: saveData
        }
    });
}

export const openPickModal = (modalStatus, callback) => (dispatch) => {

    let commonParams = {
        modalPick: {
            modalStatus: modalStatus,
            modalMessage: MODAL_PICK_OPEN,
            modalResult: null
        }
    }

    dispatch({
        type: MODAL_PICK_OPEN,
        params: commonParams
    });

    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
 }

 export const openPickModalWithAction = (modalStatus, modalAction, callback) => (dispatch) => {

    let commonParams = {
        modalPick: {
            modalStatus: modalStatus,
            modalAction: modalAction,
            modalMessage: MODAL_PICK_OPEN_WITH_ACTION,
            modalResult: null
        }
    }

    dispatch({
        type: MODAL_PICK_OPEN_WITH_ACTION,
        params: commonParams
    });

    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
 }

 export const savePickModal = (modalStatus, modalAction, modalResult, modalMessage, callback) => (dispatch) => {
    
    let commonParams = {
        modalPick: {
            modalStatus: modalStatus,
            modalAction: modalAction,
            modalMessage: modalMessage,
            modalResult: modalResult
        }
    }

    dispatch({
        type: MODAL_PICK_SAVE,
        params: commonParams
    });

    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
}
 
 export const closePickModal = (callback) => (dispatch) => {
    
    let commonParams = {
        modalPick: {
            modalStatus: null,
            modalMessage: null,
            modalResult: null
        }
    }

    dispatch({
        type: MODAL_PICK_CLOSE,
        params: commonParams
    });

    setTimeout(() => {
        if (callback) {
            callback();
        }
    }, 50);
}

export const saveCurrentTime = (startTime, endTime, timeType) => (dispatch) => {
    
    let commonParams = {
        currentTime: {
            startTime: startTime,
            endTime: endTime,
            timeType: timeType
        }
    }

    dispatch({
        type: GET_CURRENT_TIME,
        params: commonParams
    });

    
}

export const doGetDate = ( dateStatus, startTime, endTime, now) => (dispatch) => {
    dispatch({
        type: DO_GET_DATE,
        params: {
            dateStatus: dateStatus,
            filterStartTime: startTime,
            filterEndTime: endTime,
            now: now,
        }
    });
}

export const openModalLoading = (loadingText, loadingTitle) => (dispatch) => {
    dispatch({
        type: MODAL_LOADING_OPEN,
        params: {
            loadingText: loadingText,
            loadingTitle: loadingTitle
        }
    });
}

export const closeModalLoading = () => (dispatch) => {
    dispatch({
        type: MODAL_LOADING_CLOSE,
        params: {
            loadingText: null
        }
    });
}

export const openModalAlert = (alertText, alertTitle, callback) => (dispatch) => {
    dispatch({
        type: MODAL_ALERT_OPEN,
        params: {
            alertTitle: alertTitle,
            alertText: alertText,
            callback: callback
        }
    });
}

export const closeModalAlert = () => (dispatch) => {
    dispatch({
        type: MODAL_ALERT_CLOSE,
        params: {
            alertText: null
        }
    });
}

export const dispatchNotifyMsg = (notifyMsg) => (dispatch) => {
    dispatch({
        type: SEND_NOTIFY_MSG,
        params: {
            notifyMsg: notifyMsg
        }
    });
}

export const openModalTip = (tipText, refTitle, callback) => (dispatch) => {
    dispatch({
        type: MODAL_TIP_OPEN,
        params: {
            refTitle: refTitle,
            tipText: tipText,
            callback: callback
        }
    });
}

export const closeModalTip = () => (dispatch) => {
    dispatch({
        type: MODAL_TIP_CLOSE,
        params: {
            tipText: null
        }
    });
}

export const doUploadFile = (formData, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER_API_COMMON_URI + window.CONFIG.SWS_SERVER['fileUpload'] + '/uploadwithspecifictype', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Authorization' : token,
            //   'Content-Type' : 'multipart'
            },
            body: formData
          });
        
          fetchDataPromise(req, 'doUploadFile', resolve, reject);
    });

    doPost
    .then((res) => {
        let dispatchType = '';
        if (res.status === 'success') {
            dispatchType = UPLOAD_FILE_SUCCESS;
        } else {
            dispatchType = UPLOAD_FILE_FAIL;
        }
        
        dispatch({
            type: dispatchType,
            params: {
                uploadInfo: res
            }
        });
    }).catch((err) => {
        dispatch({
            type: UPLOAD_FILE_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type : UPLOAD_FILE_INIT
    });
}